export default __webpack_public_path__ + "static/media/t1.fc221124.jpg";